<template lang="pug">
  div.advantage
    figure.figure
      img(:src="item.img",
          class="img-fluid",
          alt="Technology")
    h3 {{item.title}}
    p.introduce {{item.desc}}
</template>

<script>
export default {
  name: 'Advantage',
  props: ['item']
}
</script>
<style lang="scss" scoped>
  .advantage {
    padding: 0 15px;
    margin-bottom: 1.625rem;
  }
  .figure  img {
    max-width: 100%;
    width: 100%;
    object-position: 50% 50%
  }
  .figure {
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1.43rem;
    color:#1a1a1a;
    margin: 0;
    margin-bottom: 0;
    font-family: akzidenz-grotesk-condensed;
    font-weight: 400;
    line-height: 1.1;
    color: #1a1a1a;
    text-transform: uppercase;
  }
  p {
    margin: 0;
  }
</style>
